<template>
	<div class="cke-container">
		<ckeditor :editor="editor" :config="editorConfig" v-model="editorData"  @ready="onReady">
			<div class="document-editor">
				<div class="document-editor__toolbar"></div>
				<div class="document-editor__editable-container">
					<div class="document-editor__editable"></div>
				</div>
			</div>
		</ckeditor>
	</div>
</template>

<script>

import './build/ckeditor';
import CKEditor from "@ckeditor/ckeditor5-vue2";
export default {
	name: "CKEditor",
	props: {
		value: {
			type: String,
			default: ''
		}
	},
	components: {
		ckeditor: CKEditor.component
	},
	data() {
		return {
			editor: DecoupledEditor,
			editorConfig: {
				toolbar: {
					items: [
						'undo', 'redo','|',
						'heading', '|',
						'alignment', '|',
						'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|',
						'bold', 'italic', 'strikethrough', '|',
						'link', 'blockQuote', '|',
						'outdent', 'indent', '|',
						'bulletedList', 'numberedList'
					],
				},
				shouldNotGroupWhenFull: true
			}
		};
	},
	methods: {
		onReady(editor) {
			editor.ui.getEditableElement().parentElement.insertBefore(
				editor.ui.view.toolbar.element,
				editor.ui.getEditableElement()
			);
		}
	},
	computed: {
		editorData: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit("input", value)
			}
		}
	},
}
</script>

<style>
	.cke-container {
		max-width: 100%;
	}
	.ck-editor__editable {
		margin-top: -1px !important;
		height: 240px;
		overflow-y: auto;
		border-bottom: 1px solid #c4c4c4 !important;
		border-left: 1px solid #c4c4c4 !important;
		border-right: 1px solid #c4c4c4 !important;
	}
	.ck-editor__editable > ul, .ck-editor__editable > ol {
		padding-left: 20px !important;
	}
	.ck-editor__editable > ul {
		list-style: unset;
	}
</style>
